<template>
  <v-card class="single-file-input">
    <v-card-text class="pb-4">
      <label class="form__label primary--text line__label mb-4">
        {{ labelText }}
      </label>
      <BaseButton
        class="secondary text-uppercase subtitle-2 font-weight-bold"
        @click="$emit('open-single-document-modal', itemName)"
      >
        <v-icon class="pr-4 add-icon">fa-plus</v-icon>
        Adicionar documento
      </BaseButton>
    </v-card-text>
    <DocumentDataTable
      v-if="hasDocument"
      :documents="value"
      @preview-file="onPreviewFile"
      @remove-file="onRemoveFile"
    />
  </v-card>
</template>
<script>
import DocumentsMixin from "@/mixins/DocumentsMixin";
import DocumentDataTable from "@/components/DocumentDataTable.vue";
export default {
  name: "SingleDocumentInput",
  props: {
    labelText: {
      type: String,
      default: ""
    },
    itemName: { type: String },
    value: { type: Array }
  },
  mixins: [DocumentsMixin],
  components: {
    DocumentDataTable
  },
  computed: {
    hasDocument() {
      return this.value && this.value.length;
    }
  },
  methods: {
    onRemoveFile(item) {
      this.$emit("remove-others-documents", item);
    }
  }
};
</script>

<style lang="sass">
.single-file-input
  background: #fff
  box-shadow: none !important

  .add-icon
    font-size: 15px !important

  &__footer
    background-color: var(--v-ghostWhite-base) !important

.line__label
  display: block !important
</style>
